import { render, staticRenderFns } from "./blanks.vue?vue&type=template&id=2a70bd5b&scoped=true&"
import script from "./blanks.vue?vue&type=script&lang=js&"
export * from "./blanks.vue?vue&type=script&lang=js&"
import style0 from "./blanks.vue?vue&type=style&index=0&id=2a70bd5b&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a70bd5b",
  null
  
)

export default component.exports